import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToBuildResilience');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Be proud of yourself</div>
                                            <p>This doesn’t mean shouting to the world about how great you are.
                                                It is about nurturing your self-confidence
                                                and self-esteem.</p>
                                            <div className="border_subtitle">Use determined language</div>
                                            <p>Change <span className="subtiltereg"> ‘If I can…’, ‘I hope…’, ‘Maybe…’ to ‘I can…’, ‘I will…’, ‘I must…’.</span>
                                            </p>
                                            <div className="border_subtitle">Take care of yourself</div>
                                            <p>Be good to yourself, both physically and mentally. Take up a
                                                hobby, work on that exercise regime,
                                                read a good book and get enough sleep. All of these build mental
                                                resilience.</p>
                                            <div className="border_subtitle">Accept change as an important part
                                                of life
                                            </div>
                                            <p>Change is good. It revitalises and energises. Risking an overused
                                                catchphrase: it refreshes the
                                                parts other things can’t reach.</p>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToFormulateActionPlans')}
                                                        className="link_color task button-link-redirect">How to formulate action
                                                        plans</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeAssertive')}
                                                        className="link_color task button-link-redirect">How to be assertive</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToManageYourImpact')}
                                                        className="link_color task button-link-redirect">How to manage your
                                                        impact</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToTakeControl')}
                                                        className="link_color task button-link-redirect">How to take control</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMaintainMomentum')}
                                                        className="link_color task button-link-redirect">How to maintain momentum</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToCopeWithSetbacks')}
                                                        className="link_color task button-link-redirect">How to cope with
                                                        setbacks.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Selye, H. (1956). <span
                                                    className="subtiltereg"> The Stress of Life. </span> New
                                                    York: McGraw-Hill.</p></li>

                                                <li><p className="further_info_content">Riis, J., Loewenstein,
                                                    G., Baron, J., Jepson, C., Fagerlin, A., &amp; Ubel, P. A.
                                                    (2005). Ignorance of hedonic
                                                    adaptation to hemodialysis: A study using ecological
                                                    momentary assessment. <span className="subtiltereg">Journal of Experimental
Psychology: General,</span> 134, 3–9.</p></li>
                                                <li><p className="further_info_content">Adapted from the Mayo
                                                    Clinic website:<span className="subtiltereg">  Resilience: Build Skills to Endure Hardship.</span> MayoClinic.com
                                                    <a href="http://www.mayoclinic.com/health/resilience/MH00078"
                                                       className="link_color task">http://www.mayoclinic.com/health/resilience/MH00078</a>
                                                </p></li>
                                                <li><p className="further_info_content">Adapted from Maddi,
                                                    S. &amp; Khoshaba, D. (2005).<span className="subtiltereg"> Resilience at Work: How to succeed no matter what life
throws at you.</span> New York: Amacom.</p></li>
                                                <li><p className="further_info_content"> For further reading see<span
                                                    className="subtiltereg">– 10 Tips to Build Resilience.</span> American
                                                    Psychological Association
                                                    <a href="http://psychcentral.com/lib/2007/10-tips-to-build-resilience/"
                                                       className="link_color task">http://psychcentral.com/lib/2007/10-tips-to-build-resilience/</a>
                                                </p></li>
                                                <li><p className="further_info_content">Adapted from Reivich,
                                                    K. &amp; Shatte, A. (2002). <span className="subtiltereg">The Resilience Factor: Seven essential skills for overcoming
life’s inevitable obstacles.</span> New York: Broadway Books.</p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}